'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

var _FlightLogoCarrierNumber = require('./FlightLogoCarrierNumber.jsx');

var _FlightLogoCarrierNumber2 = _interopRequireDefault(_FlightLogoCarrierNumber);

var _AvailDeparture = require('./AvailDeparture.jsx');

var _AvailDeparture2 = _interopRequireDefault(_AvailDeparture);

var _AvailArrival = require('./AvailArrival.jsx');

var _AvailArrival2 = _interopRequireDefault(_AvailArrival);

var _AvailDetails = require('./AvailDetails.jsx');

var _AvailDetails2 = _interopRequireDefault(_AvailDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AvailSegment(props) {
  var components = props.components;
  var segment = props.segment;

  var styleFlightContainer = (0, _emailStyleTools.containerStyles)(components, 'FlightContainer');

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'AvailSegment' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleFlightContainer, { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TransportationDetails_Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { verticalAlign: 'top', width: '2%' } },
                  segment.index
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '10px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '18%' } },
                  _react2.default.createElement(_FlightLogoCarrierNumber2.default, {
                    carrierCode: segment.carrier.code,
                    number: segment.flightNumber,
                    logoUrl: segment.logoUrl
                  })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '5px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '30%' } },
                  _react2.default.createElement(_AvailDeparture2.default, {
                    airport: segment.origin.name,
                    city: segment.origin.cityName,
                    terminal: segment.originTerminal,
                    time: (0, _basketHelpers.getDepartureDateTime)(segment)
                  })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '5px', paddingBottom: '0', paddingLeft: '5px', verticalAlign: 'top', width: '30%' } },
                  _react2.default.createElement(_AvailArrival2.default, {
                    airport: segment.destination.name,
                    city: segment.destination.cityName,
                    terminal: segment.destinationTerminal,
                    time: (0, _basketHelpers.getArrivalDateTime)(segment)
                  })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '0', paddingBottom: '0', paddingLeft: '5px', verticalAlign: 'top', width: '20%' } },
                  _react2.default.createElement(_AvailDetails2.default, {
                    operatedBy: (0, _basketHelpers.getOperatedBy)(segment),
                    stopovers: (0, _basketHelpers.getStopovers)(segment)
                  })
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(AvailSegment);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/AvailSegment.jsx
// module id = 1473
// module chunks = 0